import React, { useEffect, useMemo, useRef, useState } from "react";
import logo from "./assets/YM_Logo-Black.png";
import YMLogo from "./assets/YMLogo";
import useRandomColor from "./hooks/useRandomColor";
const BouncingDiv = ({
  children,
  size,
  height,
  aspectRatio,
  initialVelocity,
  cursor,
  onCLick,
}) => {
  const divRef = useRef();
  const newSize = size ? size : 75;
  const newInitialVelocity = initialVelocity ? initialVelocity : 1;
  const [width, setWidth] = useState();

  const [position, setPosition] = useState({
    x: Math.floor(Math.random() * window.innerWidth),
    y: Math.floor(Math.random() * window.innerHeight),
  });
  const [velocity, setVelocity] = useState({
    vx: generateRandomSign() * generateRandomVelocity(newInitialVelocity).x,
    vy: generateRandomSign() * generateRandomVelocity(newInitialVelocity).y,
  });
  const positionRef = useRef({ x: 0, y: 0 });
  const { generateRandomHexColor } = useRandomColor();
  const [bgColor, setBgColor] = useState(generateRandomHexColor());

  const [bounceProps, setBounceProps] = useState({
    left: 0,
    right: 0,
    top: 0,
  });

  useEffect(() => {
    const contiainer = document.getElementById("bounce-container");
    const rightSide = contiainer?.offsetWidth;
    const leftSide = 1;
    const bottomSide = contiainer?.offsetHeight;

    // setBounceProps({
    //   left: leftSide,
    //   right: rightSide,
    //   top: 0,
    //   bottom: bottomSide,
    //   divRefBottom: divRef.current.offsetTop + newSize,
    // });

    console.log(divRef.current);

    const moveDiv = () => {
      if (!contiainer || contiainer === undefined) return;
      setPosition((prevPosition) => {
        positionRef.current = prevPosition;
        return {
          x: prevPosition.x + velocity.vx,
          y: prevPosition.y + velocity.vy,
        };
      });
      if (divRef.current.offsetLeft <= leftSide) {
        setVelocity((prevVelocity) => {
          return {
            ...prevVelocity,
            vx: newInitialVelocity,
          };
        });
      }
      if (
        divRef.current.offsetLeft +
          (aspectRatio && height ? (16 * height) / 9 : newSize) >=
        rightSide
      ) {
        setVelocity((prevVelocity) => {
          return {
            ...prevVelocity,
            vx: -newInitialVelocity,
          };
        });
      }
      if (divRef.current.offsetTop <= 0) {
        setVelocity((prevVelocity) => {
          return {
            ...prevVelocity,
            vy: newInitialVelocity,
          };
        });
      }
      if (
        divRef.current.offsetTop + (aspectRatio && height ? height : newSize) >=
        bottomSide
      ) {
        setVelocity((prevVelocity) => {
          return {
            ...prevVelocity,
            vy: -newInitialVelocity,
          };
        });
      }
    };

    // Move the div continuously
    const intervalId = setInterval(moveDiv, 10);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [position, velocity, bgColor]);

  function generateRandomSign() {
    // Generate a random number between 0 and 1
    const randomNumber = Math.random();

    // Determine the sign based on the random number
    // If randomNumber < 0.5, return 1, else return -1
    return randomNumber < 0.5 ? 1 : -1;
  }

  function generateRandomVelocity(strength) {
    // Generate a random sign (-1 or 1) for both x and y directions
    const signX = generateRandomSign();
    const signY = generateRandomSign();

    // Generate random velocity components for x and y directions
    const velocityX = signX * Math.random() * strength;
    const velocityY = signY * Math.random() * strength;

    return { x: velocityX, y: velocityY };
  }

  return (
    <div
      src={logo}
      id="bounce-div"
      onClick={() => {
        onCLick
          ? onCLick()
          : setVelocity({
              vx:
                generateRandomSign() *
                generateRandomVelocity(newInitialVelocity).x,
              vy:
                generateRandomSign() *
                generateRandomVelocity(newInitialVelocity).y,
            });
      }}
      ref={divRef}
      style={{
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: `${aspectRatio && height ? (16 * height) / 9 : newSize}px`,
        minWidth: `${aspectRatio && height ? (16 * height) / 9 : newSize}px`,
        maxHeight: `${aspectRatio && height ? height : newSize}px`,
        minHeight: `${aspectRatio && height ? height : newSize}px`,
        // minHeight: `${aspectRatio ? :newSize}px`,
        left: position.x + "px",
        top: position.y + "px",
        overflow: "hidden",
        zIndex: 2,
        aspectRatio: aspectRatio ? aspectRatio : "1/1",
        cursor: cursor ? cursor : "pointer",
      }}
    >
      {children}
    </div>
  );
};

export default BouncingDiv;
